<template>
  <eg-modal
    id="upgrade-modal"
    :title="$t('account.subscription.upgradeTitle')"
    size="lg"
    centered
    scrollable
  >
    <template #modal-footer="{ close }">
      <div>
        <eg-b-button variant="outline-secondary" @click="close">{{
          $t("common.cancel")
        }}</eg-b-button>
        <eg-b-button class="ml-2" variant="info" @click="next">
          {{ $t("account.subscription.seeUpgradeOptions") }}
        </eg-b-button>
      </div>
    </template>
    <div>
      <div class="text">
        {{ $t("account.subscription.upgradeAiDetectionDescription") }}
      </div>
    </div>
  </eg-modal>
</template>

<script>
export default {
  props: {
    resolve: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    next() {
      this.$router.push("/account");
      this.$egModal.hide("upgrade-modal");
      this.resolve(true);
    },
  },
};
</script>

<style lang="scss" scoped></style>
